export class ResponseHelper {
  public Ok: boolean;
  public Mensaje: string;
  public Url: string;
  public Downfilename: string;
  public DataResponse: any;
  public Json: any;
  public Result: string;
}
